import { z } from 'zod';

const BrandSortTypeSchema = z.enum(['LATEST', 'BRAND_NAME']);

export const GetReverseProposalBrandsServiceRequestSchema = z
  .object({
    sortType: BrandSortTypeSchema.optional(),
    page: z.number().min(1),
    size: z.number().min(1).max(100),
  })
  .describe('GetReverseProposalBrandsServiceRequestSchema');

export type GetReverseProposalBrandsServiceRequest = z.infer<
  typeof GetReverseProposalBrandsServiceRequestSchema
>;

const AgreedBrandItemSchema = z
  .object({
    brand: z.string(),
    brandName: z.string(),
    logoImage: z.string(),
  })
  .describe('AgreedBrandItemSchema');

export type AgreedBrandItem = z.infer<typeof AgreedBrandItemSchema>;

export const GetReverseProposalBrandsServiceResponseSchema = z.object({
  list: z.array(AgreedBrandItemSchema),
  total: z.number(),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type GetReverseProposalBrandsServiceResponse = z.infer<
  typeof GetReverseProposalBrandsServiceResponseSchema
>;
